import axios from "axios";
import config from "../config";
import {getStoredAuthToken} from "../utils/authToken";

const {API_URL, BaseURL} = config[process.env.NODE_ENV];
export const LocalUrl = BaseURL;

export const baseUrl = API_URL;
export const baseImageUrl = `${baseUrl}/document/`;
export const baseChatImageUrl = `${baseUrl}/chat/`;
export const baseInvoiceUrl = `${baseUrl}/`;

const axiosInstance = axios.create({
  baseURL: `${baseUrl}/api/`,
  headers: {
    "ngrok-skip-browser-warning": "69420",
  },
});

export const protectedAxiosInstance = axios.create({
  baseURL: `${baseUrl}`,
  headers: {
    "ngrok-skip-browser-warning": "69420",
  },
});

protectedAxiosInstance.interceptors.request.use((config) => {
  const token = getStoredAuthToken();
  config.params = config.params || {};
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    delete config.headers.Authorization;
  }
  return config;
});

// RESPONSE INTERCEPTOR — redirect to /login on 401
protectedAxiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // A revoked/expired token must not keep AuthRoute in an authenticated
      // loop. This also lets an account unblocked by support sign in again.
      localStorage.removeItem("token");
      localStorage.removeItem("helpclic_web_push_token");
      window.location.assign("/login");
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
